import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModernComponent } from './modern/modern.component';

const routes: Routes = [
  {
    path: '',
    component: ModernComponent,
    data: {
      title: "Il Tuo Conta - Gestisci i tuoi ordini con un click"
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutsRoutingModule { }
